<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast-container" :class="type">
      <div class="toast-content">
        <div class="toast-icon">
          <svg v-if="type === 'error'" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <svg v-else-if="type === 'success'" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
        </div>
        <div class="toast-message">{{ message }}</div>
        <button class="toast-close" @click="close">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'info', // 'success', 'error', 'warning', 'info'
      duration: 3000,
      timer: null
    }
  },
  methods: {
    show(message, type = 'info', duration = 3000) {
      this.message = message;
      this.type = type;
      this.duration = duration;
      this.visible = true;
      
      if (this.timer) {
        clearTimeout(this.timer);
      }
      
      if (duration > 0) {
        this.timer = setTimeout(() => {
          this.close();
        }, duration);
      }
    },
    close() {
      this.visible = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style scoped lang="scss">
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 400px;
  min-width: 300px;
  
  .toast-content {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-left: 4px solid #007bff;
    font-size: 14px;
    line-height: 1.4;
  }
  
  .toast-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    flex-shrink: 0;
    
    svg {
      width: 100%;
      height: 100%;
    }
  }
  
  .toast-message {
    flex: 1;
    color: #333;
    font-weight: 500;
  }
  
  .toast-close {
    width: 20px;
    height: 20px;
    margin-left: 12px;
    background: none;
    border: none;
    cursor: pointer;
    color: #999;
    transition: color 0.2s;
    
    &:hover {
      color: #666;
    }
    
    svg {
      width: 100%;
      height: 100%;
    }
  }
  
  // 不同类型的样式
  &.success {
    .toast-content {
      border-left-color: #28a745;
    }
    .toast-icon {
      color: #28a745;
    }
  }
  
  &.error {
    .toast-content {
      border-left-color: #dc3545;
    }
    .toast-icon {
      color: #dc3545;
    }
  }
  
  &.warning {
    .toast-content {
      border-left-color: #ffc107;
    }
    .toast-icon {
      color: #ffc107;
    }
  }
  
  &.info {
    .toast-content {
      border-left-color: #17a2b8;
    }
    .toast-icon {
      color: #17a2b8;
    }
  }
}

// 动画效果
.toast-fade-enter-active, .toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-enter {
  opacity: 0;
  transform: translateX(100%);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>